import React from "react"

class AddFolioItemButton extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className={"btn-group add-charge-btn"}>
        {
          this.props.table_action.label == "booking_add_charge"
            ?
          <button type="button" className={"btn btn-primary dropdown-toggle "} data-toggle="dropdown">
            {I18n.t('add_charge')} <span className="caret"></span>
          </button>
            :
          <button type="button" className={"btn btn-secondary dropdown-toggle "  + (this.props.checkboxesChecked.length !== 1 ? 'disabled' : '')} data-toggle="dropdown">
            {I18n.t('add_charge')} <span className="caret"></span>
          </button>
        }

        <ul className="dropdown-menu" role="menu">
          <a className="modal-iframe dropdown-item" data-fullscreen="true" href={this.props.table_action.add_product_path + '&folio_id=' + this.props.checkboxesChecked[0]}>
            <li >
              {I18n.t('product')}
            </li>
          </a>
          {this.props.table_action.order != 'true'
            ?
            <a className="modal-iframe dropdown-item" data-fullscreen="true" href={this.props.table_action.add_room_revenue_path}>
              <li >
                {I18n.t('lodging')}
              </li>
            </a>
            :
            null
          }
          {
            this.props.table_action.label != "booking_add_charge" && this.props.table_action.order != 'true'
            ?
            <a className="modal-iframe dropdown-item" data-fullscreen="true" href={this.props.table_action.add_cancellation_fee_path}>
              <li >
                {I18n.t('cancellation_fee')}
              </li>
            </a>
            :
            null
          }
          {this.props.table_action.order != 'true'
            ?
            <a className="modal-iframe dropdown-item" data-fullscreen="true" href={this.props.table_action.add_fee_path}>
              <li >
                {I18n.t('fee')}
              </li>
            </a>
            :
            null
          }
        </ul>
      </div>
    )
  }
}

export default AddFolioItemButton
